// Ticket category badge component
import type { TicketCategory } from '../../../shared/types'
import { useTranslation } from '../../hooks/useTranslation'

interface Props {
  category: TicketCategory
  size?: 'sm' | 'md'
}

const categoryColors: Record<TicketCategory, string> = {
  support: 'bg-purple-100 text-purple-800',
  internal: 'bg-cyan-100 text-cyan-800',
  development: 'bg-indigo-100 text-indigo-800',
}

export function TicketCategoryBadge({ category, size = 'sm' }: Props) {
  const { t } = useTranslation()

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm'

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${categoryColors[category]} ${sizeClasses}`}
    >
      {t(`pages.tickets.categories.${category}` as any)}
    </span>
  )
}
